"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getIconOrLoader;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireDefault(require("react"));

var _Loader = _interopRequireDefault(require("../../Loader"));

function getIconStyles(icon) {
  if (!icon) {
    return {
      style: {},
      className: ''
    };
  }

  if ((0, _typeof2.default)(icon) === 'object') {
    return {
      style: icon.style || {},
      className: icon.className || ''
    };
  }

  if (_react.default.isValidElement(icon)) {
    return {
      style: icon.props.style || {},
      className: icon.props.className || ''
    };
  }

  return {
    style: {},
    className: ''
  };
}

function getIconOrLoader(icon, loader) {
  if (loader) {
    var iconStyles = getIconStyles(icon);

    if (typeof loader === 'boolean') {
      return _react.default.createElement(_Loader.default, iconStyles);
    } else if ((0, _typeof2.default)(loader) === 'object') {
      return _react.default.createElement(_Loader.default, (0, _extends2.default)({}, iconStyles, loader));
    }
  }

  return icon;
}